import React, { useEffect, useState } from "react"
import { Box, CircularProgress } from "@mui/material"

const Termsofservice = () => {
  const [termsHtml, setTermsHtml] = useState("")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const controller = new AbortController()
    const termsHtmlUrl = `${process.env.PUBLIC_URL}/termsofservice.html`

    const loadHtml = async () => {
      try {
        const response = await fetch(termsHtmlUrl, { signal: controller.signal })
        const text = await response.text()
        setTermsHtml(text)
      } catch (error) {
        if (error instanceof DOMException && error.name === "AbortError") {
          return
        }
        // eslint-disable-next-line no-console
        console.error("Failed to load terms of service HTML", error)
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false)
        }
      }
    }
    loadHtml()
    return () => controller.abort()
  }, [])

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", bgcolor: "background.default" }}>
      <Box sx={{ width: "100%", p: { xs: 2, md: 4 } }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
        )}
      </Box>
    </Box>
  )
}

export default Termsofservice
